import { AchievementName, ACHIEVEMENTS_CONFIGS_MAP } from '@helios/achievement';
import { Property } from '../../api/properties/types';
import { User } from '../../api/user/types';
import { LDFlags } from '../../config';
import { BadgeGridItemProps } from './BadgeGridItem/BadgeGridItem';

export const ACHIEVEMENT_TO_TARGET_MAP: Record<AchievementName, number | undefined> = Object.fromEntries(
  Object.entries(ACHIEVEMENTS_CONFIGS_MAP).map(([name, config]) => [name, config.target?.value]),
) as Record<AchievementName, number | undefined>;

export function buildAchievementMap(
  achievements:
    | { name: AchievementName; earned: boolean; progress?: { value: number }; earnedAt?: string }[]
    | undefined,
  user: User,
  property: Property,
  featureFlags?: LDFlags,
): Record<AchievementName, BadgeGridItemProps> {
  return (Object.keys(ACHIEVEMENTS_CONFIGS_MAP) as AchievementName[]).reduce((acc, name) => {
    const apiAchievement = achievements?.find((a) => a.name === name);
    if (apiAchievement && apiAchievement.earned) {
      acc[name] = {
        achievementName: name,
        achieved: true,
        numberDone: apiAchievement.progress?.value,
        dateEarned: apiAchievement.earnedAt,
      };
    } else {
      if (
        !ACHIEVEMENTS_CONFIGS_MAP[name].qualificationFunction ||
        (ACHIEVEMENTS_CONFIGS_MAP[name].qualificationFunction &&
          ACHIEVEMENTS_CONFIGS_MAP[name].qualificationFunction!({ user, property, featureFlags }))
      ) {
        acc[name] = {
          achievementName: name,
          numberDone: apiAchievement?.progress?.value ?? 0,
        };
      }
    }
    return acc;
  }, {} as Record<AchievementName, BadgeGridItemProps>);
}
